import { render, staticRenderFns } from "./agreeList.vue?vue&type=template&id=276b6424"
import script from "./agreeList.vue?vue&type=script&lang=js"
export * from "./agreeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports